// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3Fq3O","item":"item___2pONV","icon":"icon___cX1Eo","completed":"completed___33E2P"};